module.exports = __webpack_public_path__ + "static/brand09-f77d51c56085b6cba9ab141aa073059c.png";